<script>
  import { onMount } from 'svelte';
  import { surveyStore } from '../stores/surveyStore.js';
  
  onMount(() => {
    // Calculate recommendation
    surveyStore.calculateRecommendation();
    
    // Show result after 3 seconds
    const timer = setTimeout(() => {
      surveyStore.goToScreen('result', 5);
    }, 3000);
    
    return () => clearTimeout(timer);
  });
</script>

<div class="card" style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:280px;text-align:center;gap:1.5rem">
  <div class="personalizing-wrap">
    <div class="personalizing-ring"></div>
    <div class="personalizing-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p class="personalizing-label">Personalizing your recommendation…</p>
    <p class="personalizing-sub">Building your match based on your answers</p>
  </div>
</div>
